import { Suspense, lazy } from 'react';

/**
 * Lazy boundary for the WYSIWYG editor. TipTap + ProseMirror are heavy and only
 * needed in the admin content forms, so the implementation (and its deps) are
 * code-split into a separate chunk that public visitors never download. The three
 * admin pages import this wrapper exactly as before.
 */
const RichTextEditorImpl = lazy(() => import('./RichTextEditor.impl'));

export default function RichTextEditor(props) {
  return (
    <Suspense
      fallback={
        <div
          className="min-h-[16rem] animate-pulse rounded-lg border border-cream-400 bg-white"
          aria-busy="true"
          aria-label="Loading editor…"
        />
      }
    >
      <RichTextEditorImpl {...props} />
    </Suspense>
  );
}
